import { Box, Tab, Tabs, Typography } from '@mui/material';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';
import * as Redux from 'react-redux';
import { notasByBloquesPedagogicos } from '../../../boletines/BoletinesHelper';
import {
  TabPanel,
  a11yProps,
} from '../components/AsistenciasDiariasEstudiante';

const ActividadesGraficoLineComponent = () => {
  const templateStore = Redux.useSelector((state) => state.template);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [materias, setMaterias] = React.useState([]);
  const [value, setValue] = React.useState(0);
  const [proGeneral, setProGeneral] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    const materiasArray = notasByBloquesPedagogicos(
      bloquesPedagogicosStore.all,
      planEvaluacionStore.all,
      estudiantesStore.notasEvaluativas,
      estudiantesStore.actividadesExtras,
    );

    setMaterias(materiasArray);

    const proGeneral = materiasArray.reduce(
      (total, { definitiva }) => total + definitiva,
      0,
    );

    setProGeneral(proGeneral);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getGrafico = (momento) => {
    const colors = (nota) => {
      if (nota >= 16) {
        return 'green'; // Verde para calificaciones de 16 en adelante
      } else if (nota >= 10) {
        return 'orange'; // Naranja para calificaciones de 10 a 15
      } else {
        return 'red'; // Rojo para calificaciones menos de 10
      }
    };

    // Array con los datos para el gráfico
    let serie = [];
    let nombres = [];
    let def = 0;

    // Recorrer los instrumentos
    for (let item of momento.actividades) {
      const nota = item.nota;
      nombres.push(item.nombre);
      def = def + nota;
      serie.push({
        y: nota,
        name: item.nombre,
        color: colors(nota),
      });
    }

    // let remedial = null;
    // if (estudiantesStore.actividadesExtras) {
    //   remedial = estudiantesStore.actividadesExtras.find(
    //     (el) =>
    //       el.actividadExtra.tipo === 'REMEDIAL' &&
    //       el.actividadExtra.planEvaluacion.id === momento.idPlanEvaluacion,
    //   );
    // }

    const total = Math.round(def / momento.actividades.length);
    const options = {
      chart: {
        type: 'column',
      },
      title: {
        text: `<div style="text-align:center">
          ${momento.nombre}
        </div>`,
        useHTML: true,
        align: 'center',
      },
      subtitle: {
        text: `<strong>Definitiva: ${total}</strong>`,
        align: 'center',
      },
      legend: {
        enabled: false,
      },
      xAxis: {
        title: {
          text: 'Actividades asignadas',
        },
        categories: nombres,
      },
      yAxis: {
        title: {
          text: 'Nota',
        },
      },
      tooltip: {
        pointFormat: '<strong>Nota: {point.y:2f}</strong>',
      },
      series: [
        {
          name: '',
          colorByPoint: true,
          data: serie,
          dataLabels: {
            enabled: true,
            format: '{point.y}',
            style: {
              fontSize: '13px',
              fontFamily: 'Verdana, sans-serif',
            },
          },
        },
      ],
    };

    return (
      <Box
        sx={{
          border: '1px solid black',
          borderRadius: 2,
          p: 1,
          m: 1,
        }}
      >
        <HighchartsReact highcharts={Highcharts} options={options} />;
      </Box>
    );
  };

  return (
    <Box>
      <Typography variant="h6" color="initial" align="center">
        Promedio general: {proGeneral}
      </Typography>
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
        }}
      >
        {materias.length === 0 ? null : (
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={handleChange}
            aria-label="Materias"
            sx={{
              borderRight: 1,
              borderColor: 'divider',
              minWidth: '180px',
              width: '180px',
            }}
          >
            {materias.map((el, i) => {
              return (
                <Tab
                  key={`tabs_${el.id}`}
                  label={el.nombre}
                  {...a11yProps(i)}
                />
              );
            })}
          </Tabs>
        )}
        {materias.map((el, y) => {
          return (
            <TabPanel key={`tab_panel_${el.id}`} value={value} index={y}>
              <Box
                sx={{
                  width: templateStore.settings.openSidebar ? '35vw' : '45vw',
                  overflowX: 'auto',
                  transition: 'width 0.2s',
                }}
              >
                <Typography variant="body1" color="initial">
                  Promedio en la materia: {el.definitiva}
                </Typography>
                {el.bloques.map((bloque) => {
                  return getGrafico(bloque);
                })}
              </Box>
            </TabPanel>
          );
        })}
      </Box>
    </Box>
  );
};

export default ActividadesGraficoLineComponent;
